<template>
  <KeepAlive :key="componentLoader">
    <component :is="componentLoader">
      <slot></slot>
    </component>
  </KeepAlive>
</template>

<script>
import FullLayout from "./FullLayout.vue"
import BlankLayout from "./BlankLayout.vue"
import LoginLayout from "./LoginLayout.vue"

export default {
  name: 'layout',
  components: {
    FullLayout,
    BlankLayout,
    LoginLayout,
  },
  computed: {
    componentLoader() {
      return this.$route.meta.layout || 'blank-layout';
    },
  },
};
</script>
